<template>
  <!-- <div class="tabs">
    <div style="width: .26rem; height: .23rem;position: relative;top:.02rem">
      <img style="width: 100%; height: 100%" src="../../assets/images/home.png" alt="">
    </div>
    <div>
      当前位置：
      <span v-for="(item, index) in $store.getters.tabs" :key="item">
        &nbsp;&nbsp;<span>{{ item }}</span>&nbsp;<span v-if="index < $store.state.tabs.length - 1">&nbsp;></span>
      </span>
    </div>
  </div> -->
  <div class="page-banner">
    <div class="banner-content">
      <div class="title-wrapper">
        <h1>{{ $store.getters.tabs[1] }}</h1>
        <p class="subtitle">{{ enTitle[$store.getters.tabs[1]] }}</p>
      </div>
      <div class="gradient-line-fade"></div>
      <div class="breadcrumbs">
        <img :src="require('../../assets/images/home/location.png')" class="icon-img" /> 当前位置:
        <span v-for="(item, index) in $store.getters.tabs" :key="item">
          &nbsp;&nbsp;<span>{{ item }}</span>&nbsp;<span v-if="index < $store.state.tabs.length - 1">&nbsp;></span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      showTabs: [],
      enTitle: {
        '集采大厅': '/ Centralized Procurement Hall',
        '通知公告': '/ Notice',
        '帮助中心': '/ Help Center',
        '用户中心': '/ User Center',
        '关于我们': '/ About Us',
      }
    }
  },
  computed: {
    ...mapGetters(['tabs'])
  },
  mounted() {
    console.log(this.tabs)
  },
  watch: {
    "$store.state": {
      handler() {
        console.log(this.$store)
      },
      deep: true
    }
  }
}
</script>

<style lang="less" scoped>
.tabs {
  position: absolute;
  display: flex;
  color: white;
  font-size: .14rem;
  top: 8vw;
  left: 5vw;
}

.page-banner {
  position: relative;
  height: 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: left;
  text-align: center;
  overflow: hidden;

  .banner-content {
    position: relative;
    z-index: 2;
    margin-top: 1.31rem;
    margin-left: 0.87rem;
    text-align: left;
  }

  .title-wrapper {
    display: flex;
    align-items: baseline;
    gap: 20px;
  }

  h1 {
    font-family: AlibabaPuHuiTiB;
    font-size: 0.32rem;
    font-weight: bold;
    font-stretch: normal;
    line-height: 0.45rem;
    letter-spacing: 0rem;
    color: #ffffff;
  }

  .subtitle {
    font-family: ArialLight-Light;
    font-size: 0.18rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.45rem;
    letter-spacing: 0rem;
    color: #ffffff;
    opacity: 0.6;
  }

  .breadcrumbs {
    font-size: 0.16rem;
    color: rgba(255, 255, 255, 0.9);

    .ivu-icon {
      margin-right: 5px;
    }

    .icon-img {
      width: 0.14rem;
      height: 0.17rem;
      margin-right: 0.11rem;
      margin-bottom: 0.02rem;
      vertical-align: middle;
    }
  }
}

.gradient-line-fade {
  width: 5.39rem;
  height: 0.01rem;
  margin-bottom: 0.20rem;
  margin-top: 0.20rem;
  /* 线的高度 */
  background: linear-gradient(to left,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.4) 100%);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/tabs/index.vue